import * as React from 'react';
import { RowModel } from '@tanstack/react-table';
import { Waypoint } from 'react-waypoint';

import { NewTableDefaultDataItem, NewTableGetId } from '@common/components/new-table/new-table.types';
import { Row } from './components/row';

import './body.styles.scss';

export type BodyProps = {
  rootRef: React.MutableRefObject<HTMLDivElement | undefined>;
  getId: NewTableGetId;
  onRowContextMenu?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
  isRowSelected?: (item: NewTableDefaultDataItem) => boolean;
  itemUniqProperty: string;
  model: RowModel<NewTableDefaultDataItem>;
  onRowClick?: (params: { item: NewTableDefaultDataItem; e: React.MouseEvent<HTMLTableRowElement> }) => void;
  onLazyLoad?: () => void;
};

export const Body: React.FC<BodyProps> = (props) => {
  const { rootRef, model, itemUniqProperty, getId, onRowClick, isRowSelected, onRowContextMenu, onLazyLoad } = props;

  const handleLazyLoadEnter = React.useCallback(({ event }: Waypoint.CallbackArgs) => {
    if (event && onLazyLoad) {
      onLazyLoad();
    }
  }, [onLazyLoad]);

  return (
    <tbody>
      {model.rows.map((row, index) => (
        <Row
          getId={{
            root: getId.bodyRow(row.original, index),
            cell: getId.bodyCell,
          }}
          index={index}
          key={row.original[itemUniqProperty]} 
          model={row} 
          selected={isRowSelected ? isRowSelected(row.original) : undefined}
          onClick={onRowClick} 
          onContextMenu={onRowContextMenu}
        />
      ))}
      {onLazyLoad && model.rows.length > 0 && (
        <Waypoint
          scrollableAncestor={rootRef.current}
          topOffset={40}
          onEnter={handleLazyLoadEnter}
        >
          <tr className="NewTable__body__lazy-load-element" />
        </Waypoint>
      )}
    </tbody>
  );
};